export enum EnumExamFormat {
    Reading = "Reading",
    Writing = "Writing",
    Listening = "Listening",
}
